import { ShowWithAlphabetItems, nameItems, rowsPerPageItems, viewItems } from './offCyclePayrollConstants';

import { EnhancedDropDownRHF } from '@websential/cosmic-v20'
import { Grid } from '@mui/material'
import React from 'react'

interface ICalculatedOffCyclePayrollSetupHeaderPanel {
    departmentsDDLItems: any;
    calculatedOffCyclePayrollTableData: any;
}
export const CalculatedOffCyclePayrollSetupHeaderPanel: React.FC<ICalculatedOffCyclePayrollSetupHeaderPanel> = ({ departmentsDDLItems, calculatedOffCyclePayrollTableData }) => {
    return (
        <>
            {calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.items && calculatedOffCyclePayrollTableData.items.length > 0 && <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 5px 0 5px",
                    // marginTop:"3rem",
                    "& .dropDownWrapper": { marginBottom: "0!important" },
                    "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" }
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>

                    <EnhancedDropDownRHF
                        selectName="viewCalculated"
                        testId={`viewCalculated`}
                        items={viewItems}
                        selectedItem={100}
                    // onSelectionChangeHandler={onNameChangeHandler}
                    />
                </Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>

                    <EnhancedDropDownRHF
                        selectName="nameCalculated"
                        testId={`nameCalculated`}
                        items={nameItems}
                        selectedItem={100}
                    // onSelectionChangeHandler={onNameChangeHandler}
                    />
                </Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="ShowWithAlphabetCalculated"
                        testId={`ShowWithAlphabetCalculated`}
                        items={ShowWithAlphabetItems}
                        selectedItem={"all"}
                    // onSelectionChangeHandler={onShowWithAlphabetDDLChangeHandler}
                    /></Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="departmentsCalculated"
                        testId={`departmentCalculated`}
                        selectedItem={"all"}
                        // onSelectionChangeHandler={onDepartmentsDDLChangeHandler}
                        items={departmentsDDLItems ?? []}
                    /></Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="rowsPerPageItemsCalculated"
                        testId={`rowsPerPageItemsCalculated`}
                        items={rowsPerPageItems}
                        selectedItem={100}
                    // onSelectionChangeHandler={onRowsPerPageItemsDDLChangeHandler}
                    /></Grid>
            </Grid>}

        </>
    )
}

